import { Box, Button } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import Modal from "components/modal/Modal";
import { ReportSignatureKeyResult } from "domain/reportSignatureKeys";
import form from "styles/form.scss";

import testIds from "testIds.json";

interface Props {
    result?: ReportSignatureKeyResult;
    onClose: () => void;
}

const ReportSignatureKeyResultModal = (props: Props) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={props.result != null} hideModal={props.onClose} modalTitle={props.result?.title}>
            <Box className={form.deleteContainer}>{props.result?.message}</Box>
            <Box horizontalAlignment={"Right"}>
                <Button variant={"Primary"} onClick={props.onClose} testId={testIds.common.dialog.closeButton}>
                    {t("Common.ok")}
                </Button>
            </Box>
        </Modal>
    );
};

export default ReportSignatureKeyResultModal;
